import "expo-router/entry";
import "./src/unistyles";
